export default __webpack_public_path__ + "static/src/assets/images/icons/nav_icon_e-statements_normal.png";